import React, { Component } from 'react';
import T from 'i18n-react';
import configureT from './configureT';
import TestimonialForm from './TestimonialForm';
import SuccessInfo from './SuccessInfo';
import logo from '../assets/img/airrefund.png';
import gql from 'graphql-tag';
import { graphql, compose, withApollo } from 'react-apollo';
import Spinner from './Spinner';
import message from './Message';

const availableStates = [
  'b6_testimonial_sent',
  'b6_reminder_testimonial',
  'c8_testimonial_sent',
  'c8_reminder_testimonial'
]
class Testimonial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      successInfo: false,
      claimUnavailable: false
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps && !this.props.data.testimonial && nextProps.data.testimonial) {
      configureT(nextProps.data.testimonial.passengerLanguage, 'testimonial')
    }
  }

  showSuccessInfo = () => this.setState({ successInfo: true });

  handleSubmit = (inputData) => {
    this.props.client.mutate({
      mutation: SendTestimonial,
      variables: {
        input: {
          ...inputData,
          token: urlParams.get('id')
        }
      }
    }).then(({ data }) => {
      this.setState({successInfo: true})
    }).catch((error) => {
      console.dir(error)
      this.setState({errorInfo: true});
      window.scrollTo(0,0)
    });
  }

  render() {
    try {
      if(this.props.data.loading){
        return <Spinner />;
      }
      if (this.state.successInfo) { //when does it happen?
        return <SuccessInfo title={T.translate('successMessage')} />;
      }
      if (!(
        this.props.data.testimonial
        && this.props.data.testimonial.passengerLanguage
        && this.props.data.testimonial.crmState
      )) {
        return message('Oups! Something went wrong!');
      }
      else {
        const language = this.props.data.testimonial.passengerLanguage !== 'Slovak' ? this.props.data.testimonial.passengerLanguage : 'English';
        const crmState = this.props.data.testimonial.crmState;
        configureT(language, 'testimonial');
        if (this.state.claimUnavailable || language === 'French' || !availableStates.includes(crmState)) {
          return message('This claim is currently unavailable');
        }
        else {
          return (
            <div className="testimonial site-template">
              <header className="header">
                <img src={logo} alt="airrefund logo" />
              </header>
              <div className="container">
                <h1
                  className="container__header"
                  style={{ fontSize: this.state.language === 'Croatian' ? '2rem' : '2.85rem' }}
                >
                  {T.translate('header')}
                </h1>
                <TestimonialForm showSuccessInfo={this.showSuccessInfo} handleSubmit={this.handleSubmit}/>
              </div>
            </div>
          );
        }
      }
    } catch (error) {
      console.log(error);
      return message('Oups! Something went wrong!')
    }
  }
}

const TestimonialData = gql`
  query($token: String!){
    testimonial(token: $token){
      passengerLanguage
      crmState
    }
  }
`
const SendTestimonial = gql`
  mutation AddTestimonial($input: TestimonialMutationInput!){
    testimonial(input: $input) {
      testimonial {
        id
      }
    }
  }
`

const urlParams = new URLSearchParams(window.location.search)

const TestimonialWithData = compose(
  withApollo,
  graphql(TestimonialData, {
    options: {
      variables : {
        token: urlParams.get('id')
      }
    }
  })
)(Testimonial)

export default TestimonialWithData



// WEBPACK FOOTER //
// ./src/components/Testimonial.js